import type { ApiRoute, NoBody, NoPathParams } from "../../api"
import type { ExteriorColorOptionView } from "../../common/colors/exteriorColor/ExteriorColorOptionView"
import type { GetExteriorColorOptionsQueryParams } from "../../common/colors/exteriorColor/GetExteriorColorOptionsQueryParams"

export const getExteriorColorOptionsRoute: ApiRoute<
	NoPathParams,
	GetExteriorColorOptionsQueryParams,
	NoBody,
	ExteriorColorOptionView[]
> = {
	buildUrl: () => "/colors/exterior-color/options",
	method: "get",
	path: "/colors/exterior-color/options",
}
